import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IIntegrationsHealthSummary } from './types';

export const ADMIN_INTEGRATIONS_HEALTH_QUERY_KEY = 'admin/integrationsHealth';

export function useAdminIntegrationsHealthQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IIntegrationsHealthSummary>('admin/integrationsHealth', 'GET'),
		queryKey: [ADMIN_INTEGRATIONS_HEALTH_QUERY_KEY],
		enabled,
		refetchOnWindowFocus: false,
		meta: {
			toastErrorMessage: "Couldn't load integrations health.",
			errorLogging: { fn: 'useAdminIntegrationsHealthQuery' },
		},
	});
}
